import React from 'react';
import logo from '@/assets/images/OpenPath_FeatureGraphic_flush.png';

const LogoCard = ({ className = '', height, width }) => {
  const props = { height, width };
  return (
    <img src={logo} alt="Logo" className={`logo-image ${className}`} {...props} />
  );
};

export default LogoCard;
